import { Alert } from './Alert'
import { useAlert } from '../../context/AlertContext'

type Props = {
  gameOver: boolean
  modalsOpen: boolean
  solution: string
  solutionUrl?: string
}

export const AlertContainer = ({
  gameOver,
  solution,
  modalsOpen,
  solutionUrl,
}: Props) => {
  const { message, status, isVisible } = useAlert()
  if (isVisible)
    return (
      <Alert
        isOpen={true}
        message={message || ''}
        variant={status}
        modalsOpen={modalsOpen}
      />
    )
  return (
    <img
      className="wordle-logo-img"
      src="https://static.dicio.com.br/img/cata_letras/cata-letras-logo.png"
      srcSet="https://static.dicio.com.br/img/cata_letras/cata-letras-logo.png, 
      https://static.dicio.com.br/img/cata_letras/cata-letras-logo.svg 2x"
      data-fallback="https://static.dicio.com.br/img/cata_letras/cata-letras-logo.png"
      alt="Cata-Letras, o jogo de palavras do Dicio"
      title="Cata-Letras, o jogo de palavras do Dicio"
    />
  )
}
